import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Dimmer, Header, Loader } from 'semantic-ui-react';
import NoCards from './NoCards';
import './savedcards.css';
import { deleteStoredCard, listStoredCards } from './CardsActions';
import SavedCard from './SavedCard';

const mapState = state => ({
  async: state.async,
  auth: state.auth,
  fetchedCards: state.cards.fetchedCards,
});

const actions = {
  deleteStoredCard,
  listStoredCards,
};

class SavedCardsContainer extends Component {
  static propTypes = {
    async: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    deleteStoredCard: PropTypes.func.isRequired,
    listStoredCards: PropTypes.func.isRequired,
    fetchedCards: PropTypes.object,
    inlineLoad: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    // Destructure props
    const {
      auth: { csrfRequestIdentifier, migration },
      listStoredCards,
      fetchedCards,
    } = props;

    if (typeof listStoredCards === 'function' && !fetchedCards) {
      // If cards not pre-fetched, then fetch it
      listStoredCards(
        csrfRequestIdentifier,
        migration && migration.walletToken
      );
    }
  }

  deleteCard = (card) => {
    const { auth: { csrfRequestIdentifier, migration }, deleteStoredCard } = this.props;
    
    // delete action
    deleteStoredCard(card.cardToken, csrfRequestIdentifier, migration.walletToken);
  }

  render() {
    const { async, fetchedCards, inlineLoad } = this.props;

    // Default, show no cards image
    let content = <NoCards />;

    const inlineLoader = inlineLoad ?  (
      <Dimmer
        active={async.loading}
        inverted
      >
        <Loader content="Please wait, fetching. . ." />
      </Dimmer>
    ) : null;

    // From fetch cards, map and return single card option row.
    if (fetchedCards && fetchedCards.cards && Array.isArray(fetchedCards.cards) && fetchedCards.cards.length > 0) {
      content = fetchedCards.cards.map(card => {
         // single card
        return (
          <SavedCard
            card={card}
            key={card.cardToken}
            deleteCard={this.deleteCard}
          />
        );
      });
    }
    return (
      <div className="saved-cards-feature">
        <Header as="h1">Saved Cards {inlineLoad && async.loading && "inlineLoad"}</Header>
        {inlineLoader}
        {content}
      </div>
    );
  }
}

export default connect(
  mapState,
  actions
)(SavedCardsContainer);